import React, { Component } from 'react';
import PropTypes from 'prop-types';

import OilOrderDetails from './OilOrderDetails';

class OilOrderGroupDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      groupTotal: 0,
    };

    this.calculateTotal = this.calculateTotal.bind(this);
  }

  componentWillMount() {
    this.calculateTotal();
  }

  calculateTotal() {
    let total = 0;
    this.props.orders.forEach((order) => {
      total += order.oilOrder.quantity;
    });

    this.setState({ groupTotal: total });
  }
  renderTotal() {
    return (
      <div className="total right">
        <hr />
        <strong>{this.props.groupName} Total: {parseFloat(this.state.groupTotal).toFixed(1)} Gal</strong>
      </div>
    );
  }
  renderOrders() {
    return this.props.orders.map(order =>
      <OilOrderDetails key={order.id} order={order} />);
  }

  renderOrderGroupHeadings() {
    return (
      <div className="report-item-headings">
        <div className="report-col-temp">Invoice # </div>
        <div className="report-col-temp">Closed Date</div>
        <div className="report-col-temp">Fulfilled</div>
        <div className="report-col-temp">Sold To</div>
        <div className="report-col-temp">Aircraft</div>
        <div className="report-col-temp">Oil Type</div>
        <div className="report-col-temp">Quantity</div>
        <div className="clear" />
      </div>
    );
  }

  render() {
    return (
      <span>
        <h4> {this.props.groupName} </h4>
        {this.renderOrderGroupHeadings()}
        <article className="order-item">
          {this.renderOrders()}
        </article>
      </span>
    );
  }
}

OilOrderGroupDetails.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.shape({
    oilOrder: PropTypes.shape({}).isRequired,
  }).isRequired).isRequired,
};

export default OilOrderGroupDetails;



// WEBPACK FOOTER //
// ./src/Containers/Reports/MonthlyOil/OilOrderGroupDetails.js